// Everyone in the room is called "Guest" until the player learns to ask for a
// name, and even afterwards names are unverified and freely duplicated. Bans,
// though, key on `vid`. So a moderator looking at three identical "Guest" rows
// needs something stable and vid-derived to tell them apart before they act,
// or they are moderating blind.
//
// The full vid is an opaque hex string and would dominate a dense row, so this
// gives two small, deterministic handles instead: a short suffix and a colour.

// Chosen to stay legible on the dashboard's dark surfaces and to be
// distinguishable from each other, including for the common forms of colour
// blindness — the colour is a hint that two rows differ, never the only one.
const SWATCHES = [
	'#f0b429', '#4fd1c5', '#a78bfa', '#f472b6',
	'#7dd3fc', '#86efac', '#fbbf24', '#fb923c'
]

/** FNV-1a, for a stable colour across reloads and across moderators. */
function hash(value) {
	let h = 0x811c9dc5
	for (let i = 0; i < value.length; i++) {
		h ^= value.charCodeAt(i)
		h = Math.imul(h, 0x01000193) >>> 0
	}
	return h
}

export function viewerColor(vid) {
	if (!vid) return SWATCHES[0]
	return SWATCHES[hash(vid) % SWATCHES.length]
}

/**
 * The tail of the vid, which is the part that actually varies — ids look like
 * `anon-8f2c1d`, so the shared prefix carries no information.
 */
export function viewerTag(vid) {
	if (!vid) return ''
	const tail = String(vid).replace(/[^a-zA-Z0-9]/g, '')
	return tail.slice(-4).toLowerCase()
}
